import axios from 'axios';
import {
    clearStoredAuthPhone,
    clearStoredAuthToken,
    getRuntimeConfig,
    getStoredAuthToken
} from '@/widgets/booking/config/runtime';
export const http = axios.create({
    timeout: 10000,
    validateStatus: () => true
});
function isExpectedMissingClientResponse(status, url, responseData) {
    if (status !== 400) {
        return false;
    }
    if (url !== 'user') {
        return false;
    }
    const message = responseData?.message || responseData?.error || '';
    return message.includes('Пользователь не найден');
}
function handleUnauthorizedResponse(status) {
    if (status !== 401) {
        return;
    }
    clearStoredAuthToken();
    clearStoredAuthPhone();
}
http.interceptors.request.use((config) => {
    const runtimeConfig = getRuntimeConfig();
    const baseDomain = runtimeConfig.domain.replace(/\/$/, '');
    config.baseURL = `${baseDomain}/api/v1.1`;
    config.headers = config.headers || {};
    config.headers.Club = runtimeConfig.club;
    config.headers.Source = 'booking-widget';
    config.headers.Accept = 'application/json';
    if (config.headers.Authorization) {
        return config;
    }
    const authToken = getStoredAuthToken();
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
});
http.interceptors.response.use((response) => {
    handleUnauthorizedResponse(response.status);

    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    if (isExpectedMissingClientResponse(response.status, response.config?.url, response.data)) {
        console.warn('[booking-widget] Authorized user has no client profile, using phone fallback');
        return response;
    }
    const requestUrl = `${response.config?.baseURL || ''}/${response.config?.url || ''}`.replace(/([^:]\/)\/+/g, '$1');
    const requestMethod = String(response.config?.method || 'GET').toUpperCase();
    const responseMessage = response.data?.message
        || response.data?.error
        || `Request failed with status code ${response.status}`;
    console.error('[booking-widget] API request failed', {
        method: requestMethod,
        url: requestUrl,
        status: response.status,
        params: response.config?.params,
        data: response.config?.data,
        response: response.data || null,
        message: responseMessage
    });
    return response;
}, (error) => {
    handleUnauthorizedResponse(error.response?.status);

    const requestUrl = `${error.config?.baseURL || ''}/${error.config?.url || ''}`.replace(/([^:]\/)\/+/g, '$1');
    const requestMethod = String(error.config?.method || 'GET').toUpperCase();
    const status = error.response?.status;
    const responseMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Request failed';
    console.error('[booking-widget] API request failed', {
        method: requestMethod,
        url: requestUrl,
        status,
        params: error.config?.params,
        data: error.config?.data,
        response: error.response?.data || null,
        message: responseMessage
    });
    const normalizedError = new Error(responseMessage);
    normalizedError.status = status;
    normalizedError.url = requestUrl;
    normalizedError.method = requestMethod;
    return Promise.reject(normalizedError);
});
//# sourceMappingURL=http.js.map
